import blocks from '@dfb/gatsby-dfb-theme/src/components/blocks'
import MDataCenter from '../../../components/blocks/m_datacenter'
import MFurtherLinks from '../../../components/blocks/m_further_links'
import MForm from './blocks/Forms/m_form'
import MAccordion from './blocks/m_accordion'
import MImage from './blocks/m_image'
import MImageCarousel from './blocks/m_image_carousel'
import MDistributor from './blocks/m_distributor'
import MMycrocast from './blocks/m_mycrocast'
import MCareerFacts from './blocks/m_career_facts'
import MPeople from './blocks/m_people'
import MOpenQuestion from './blocks/m_open_question'
import MMissionStatement from './blocks/m_mission_statement'
import MMultipleCtaButtons from './blocks/m_multiple_cta_buttons'
import MFanclubMap from './blocks/m_fanclub_map'
import MFanclubTable from './blocks/m_fanclub_table'
import MCardTeasers from './blocks/m_card_teasers'

export default Object.assign(blocks, {
  m_accordion_element: MAccordion,
  m_data_center: MDataCenter,
  m_formular: MForm,
  m_image_slider: MImageCarousel,
  m_image: MImage,
  m_related_links: MFurtherLinks,
  m_mycrocast: MMycrocast,
  m_distributor: MDistributor,
  m_mission_statement: MMissionStatement,
  m_career_facts: MCareerFacts,
  m_people: MPeople,
  m_open_question: MOpenQuestion,
  m_fanclub_map: MFanclubMap,
  m_fanclub_table: MFanclubTable,
  m_multiple_cta_buttons: MMultipleCtaButtons,
  m_card_teaser: MCardTeasers,
})
